import React from 'react'

import SampleReview from './parts/SampleReview'

const SubmitProductReviewThankYouScreen = ({ review, productId }) => {
  let product = review.products.find(product => {
    return product.productId === productId
  })

  return (
    <div className={`product-review-thankyou`}>
      <div className="intro">
        <h1 dangerouslySetInnerHTML={{ __html: review.reviewThankyouTitle }} />
        <div
          className="detail"
          dangerouslySetInnerHTML={{ __html: review.reviewThankyouDescription }}
        />
        <div
          className="detail"
          dangerouslySetInnerHTML={{ __html: review.reviewThankyouFooter }}
        />
      </div>

      {product && product.sampleReviews && (
        <div className="sample-reviews">
          <h3 className="title">Other Customer Reviews</h3>
          <div className="sample-review-list">
            {product.sampleReviews.map((sampleReview, i) => {
              return (
                <SampleReview
                  key={i}
                  title={sampleReview.title}
                  displayDate={sampleReview.created}
                  reviewBody={sampleReview.detail}
                  nickname={sampleReview.nickname}
                  rating={sampleReview.rating}
                  outOf={5}
                />
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default SubmitProductReviewThankYouScreen
